import host from '@/objetos/host.js'

const { PROTOCOLO, HOST, PORT } = host

const redireccionar = modulo => {
 
    window.location = `${PROTOCOLO}//${HOST}:${PORT}${modulo}`

}

export default redireccionar